<div *ngIf="!isMobile">
  <a  *ngIf="isWebGLSupported" class="btn-primary-container">
    <!-- <a class="btn-primary-container"> -->
    <button  type="button" class="btn btn-primary jqFenster" data-mellon-iframe-url="/registration/index" data-selector="#mellonModal">
      <span i18n="@@title">Join now!</span>
    </button>
  </a>
  <a *ngIf="!isWebGLSupported" class="btn-primary-container" href="https://www.arkheim.com/PATCH/ArkheimLauncherInstaller.exe">
    <button type="button" class="btn btn-primary" >
      <span i18n="@@titleDownload">Download Now!</span>
    </button>
  </a>

</div>
<div *ngIf="isMobile" class="btn-store-container">
  <android-button *ngIf="isAndroid"></android-button>
  <ios-button *ngIf="isIOs"></ios-button>
</div>
